module.exports = __webpack_public_path__ + "img/Group 1080seven.b3bd84fc.png";